import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ProjectTable from "./components/ProjectTable";
import ProjectView from "./components/ProjectView";
import UserManagement from "./components/UserManagement";
import ContactsView from "./components/ContactsView";
import AccountsView from "./components/AccountsView";
import MaterialsView from "./components/MaterialsView";
import MaterialOrderView from "./components/MaterialOrderView";
import MaterialOrderView2 from "./components/MaterialOrderView2";
import LabourItemsView from "./components/LabourItemsView";
import PayrollSubmission from "./components/PayrollSubmission";
import PODetailView from "./components/PODetailView";
import PODetailView2 from "./components/PODetailView2";
import StockOutOrderDetailView from "./components/StockOutOrderDetailView";
import POForm2 from "./components/POForm2";
import WOForm2 from "./components/WOForm2";
import CreatePieceworkerLog3 from "./components/CreatePieceworkerLog3";
import PieceworkerLogDetail3 from "./components/PieceworkerLogDetail3";
import FinanceDashboard from "./components/FinanceDashboard3";
import OverheadPage from "./components/OverheadPage"; // adjust path
import ProspectsTab from "./components/ProspectsTab";
import POForm from "./components/POForm";
import ChangeOrderForm from "./components/ChangeOrderForm";
import StockOutOrderView from "./components/StockOutOrderView";
import ItemDatabase from "./components/ItemDatabase";
import TakeoffPage from "./components/TakeoffPage";
import ChangeOrderForm2 from "./components/ChangeOrderForm2";
import Opportunities from "./components/Opportunities.js";
import EditChangeOrderForm from "./components/EditChangeOrderForm";
import EditChangeOrderForm2 from "./components/EditChangeOrderForm2";
import EditMaterialOrderView from "./components/EditMaterialOrderView";
import EditMaterialOrderView2 from "./components/EditMaterialOrderView2";
import ConditionPDFtoExcel from "./components/ConditionPDFtoExcel";
import SOVTab from "./components/SOVTab";
import Leads from "./components/Leads.js";
import PODetailView3 from "./components/PODetailView3";
import WorkOrderView3 from "./components/WorkOrderView3";
import CreatePieceworkRequest from "./components/CreatePieceworkRequest";
import CreatePO3 from "./components/CreatePO3";
import CreateWO3 from "./components/CreateWO3";
import ModuleBuilderPage from "./components/ModuleBuilderPage";
import LeadDetails from "./components/LeadDetails.js";
import UserProfile from "./components/UserProfile";
import WorkOrderView from "./components/WorkOrderView";
import WorkOrderView2 from "./components/WorkOrderView2";
import DailyLogViewEdit from "./components/DailyLogViewEdit";
import FinancesView from "./components/FinancesView";
import TimesheetTable from "./components/TimesheetTable";
import TimesheetDetail from "./components/TimesheetDetail";
import AddTimesheet from "./components/AddTime";
import PieceWorkerLog from "./components/PieceWorkerLogMainTab.js";
import PieceworkerLogDetail from "./components/PieceworkerLogDetail";
import PieceworkerLogDetail2 from "./components/PieceworkerLogDetail2";
import BillsTableView from "./components/BillsTableView";
import InvoiceUploadPage from "./components/InvoiceUploadPage";
import SharePointFilesTab from "./components/SharePointFilesTab";
import QuickBooksError from "./components/QuickBooksError.js";
import EditMaterialOrder3 from "./components/EditMaterialOrder3.js";
import QuickBooksSuccess from "./components/QuickBooksSuccess.js";
import PayrollView from "./components/PayrollView.js";
import Callback from "./components/Callback";
import ProgressLogDetail from "./components/ProgressLogDetails.jsx";
import InventoryManagement from "./components/InventoryManagement.jsx";
import SubAgreementsPage from "./components/SubAgreementsPage";

const Bills3TablePage = BillsTableView;

export default function AppRoutes({ user, companyProfile }) {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/Projects" />} />
      <Route path="/Projects" element={<ProjectTable userId={user.id} />} />
      <Route path="/Projects/:id" element={<ProjectView />}>
        <Route
          path="sharepoint"
          element={
            <SharePointFilesTab
              projectName=""
              sharePointFolderName={companyProfile?.sharePointSite}
            />
          }
        />
      </Route>
      <Route
        path="/projects/:id/purchase-orders3/new"
        element={<CreatePO3 />}
      />
      <Route
        path="/projects/:id/purchase-orders3/:poId"
        element={<PODetailView3 />}
      />
      <Route path="/piecework/submit" element={<CreatePieceworkRequest />} />
      <Route path="/modules/new" element={<ModuleBuilderPage />} />
      <Route path="/modules/:moduleId/edit" element={<ModuleBuilderPage />} />
      <Route
        path="/projects/:id/pieceworker-logs3/new"
        element={<CreatePieceworkerLog3 />}
      />
      <Route path="/takeoff" element={<TakeoffPage />} />
      <Route path="/piecework-logs3/:id" element={<PieceworkerLogDetail3 />} />
      <Route path="/projects/:id/work-orders3/new" element={<CreateWO3 />} />
      <Route
        path="/projects/:id/work-orders3/:woId"
        element={<WorkOrderView3 />}
      />
      <Route path="/Projects/:id/purchase-orders/new" element={<POForm />} />
      <Route
        path="/projects/:id/material-orders3/:orderId"
        element={<EditMaterialOrder3 />}
      />
      <Route path="/overhead" element={<OverheadPage />} />
      <Route path="/overhead" element={<OverheadPage />} />
      <Route path="/Projects/:id/purchase-orders2/new" element={<POForm2 />} />
      <Route path="/Projects/:id/work-orders2/new" element={<WOForm2 />} />
      <Route path="/Opportunities" element={<Opportunities />} />
      <Route path="/Opportunities/:opportunityId" element={<Opportunities />} />
      <Route path="/timesheets" element={<TimesheetTable />} />
      <Route path="/timesheet/:id" element={<TimesheetDetail />} />
      <Route path="/addTimesheet" element={<AddTimesheet />} />
      <Route path="/Leads" element={<Leads />} />
      <Route path="/Leads/:id" element={<LeadDetails />} />
      <Route path="/pieceworkerlog" element={<PieceWorkerLog />} />
      <Route path="/item-database" element={<ItemDatabase />} />
      <Route path="/piecework-logs/:id" element={<PieceworkerLogDetail />} />
      <Route path="/piecework-logs2/:id" element={<PieceworkerLogDetail2 />} />
      <Route path="/progress-logs/:id" element={<ProgressLogDetail />} />
      <Route
        path="/Projects/:id/change-orders/new"
        element={<ChangeOrderForm />}
      />
      <Route
        path="/Projects/:id/change-orders2/new"
        element={<ChangeOrderForm2 />}
      />
      <Route
        path="/projects/:id/change-orders/:changeOrderId/edit"
        element={<EditChangeOrderForm />}
      />
      <Route path="/inventory" element={<InventoryManagement />} />
      <Route
        path="/projects/:id/change-orders2/:changeOrderId/edit"
        element={<EditChangeOrderForm2 />}
      />
      <Route
        path="/Projects/:id/change-orders/:changeOrderId"
        element={<ChangeOrderForm />}
      />
      <Route
        path="/users"
        element={
          user.role === "admin" || user.role === "project_manager" ? (
            <UserManagement />
          ) : (
            <Navigate to="/Projects" />
          )
        }
      />
      <Route path="/quickbooks-success" element={<QuickBooksSuccess />} />
      <Route
        path="/projects/:id/stock-out-order"
        element={<StockOutOrderView />}
      />
      <Route
        path="/projects/:id/stock-out-order/:orderId"
        element={<StockOutOrderDetailView />}
      />
      <Route path="/subAgreements" element={<SubAgreementsPage />} />
      <Route path="/quickbooks-error" element={<QuickBooksError />} />
      <Route path="/contacts" element={<ContactsView />} />
      <Route path="/accounts" element={<AccountsView />} />
      <Route path="/daily-logs/:logId" element={<DailyLogViewEdit />} />
      <Route path="/pdfcondition" element={<ConditionPDFtoExcel />} />
      <Route path="/materials" element={<MaterialsView />} />
      <Route path="/labour-items" element={<LabourItemsView />} />
      <Route path="/Prospects" element={<ProspectsTab />} />
      <Route path="/Prospects/:prospectId" element={<ProspectsTab />} />
      <Route
        path="/Projects/:id/workorders3/:woId"
        element={<WorkOrderView3 />}
      />
      <Route path="/finances" element={<FinancesView />} />
      <Route
        path="/projects/:id/workorders/:woId"
        element={<WorkOrderView />}
      />
      <Route
        path="/projects/:id/workorders2/:woId"
        element={<WorkOrderView2 />}
      />
      <Route
        path="/payroll-submission"
        element={
          user.role === "admin" || user.role === "project_manager" ? (
            <PayrollSubmission />
          ) : (
            <Navigate to="/" />
          )
        }
      />
      <Route
        path="/projects/:id/material-order"
        element={<MaterialOrderView />}
      />
      <Route
        path="/projects/:id/material-order2"
        element={<MaterialOrderView2 />}
      />
      <Route
        path="/projects/:id/material-order/:orderId"
        element={<EditMaterialOrderView />}
      />
      <Route
        path="/projects/:id/material-order2/:orderId"
        element={<EditMaterialOrderView2 />}
      />
      <Route path="/users/:userId" element={<UserProfile />} />
      <Route
        path="/projects/:id/purchase-orders/:poId"
        element={<PODetailView />}
      />
      <Route
        path="/projects/:id/purchase-orders2/:poId"
        element={<PODetailView2 />}
      />
      <Route path="/projects/:id/sov" element={<SOVTab />} />
      <Route path="/projects/:id/sov/:sovId" element={<SOVTab />} />
      <Route
        path="/payroll"
        element={user.role === "admin" ? <PayrollView /> : <Navigate to="/" />}
      />
      <Route
        path="/finance-dashboard"
        element={
          user.role === "admin" ? <FinanceDashboard /> : <Navigate to="/" />
        }
      />
      <Route path="/bills" element={<BillsTableView userId={user.id} />} />
      <Route path="/bills3" element={<Bills3TablePage />} />
      <Route path="/bills3/upload" element={<InvoiceUploadPage />} />
      <Route
        path="/invoice-upload"
        element={<InvoiceUploadPage userId={user.id} />}
      />
      <Route path="*" element={<Navigate to="/Projects" />} />
    </Routes>
  );
}
